export const fieldsRules = {
    fieldsToRemove: [
        "applicantSchedule",
        "applicantEmail",
        "applicantWhatsapp",
        "applicantHistoryData",
        "applicantRating",
        // "applicantAssessments",
        "applicantJobMatch",
        "applicantQuestionnaires"
    ],
    formsToRemove: [
        "applicantHistoryData",
        "applicantEmailData",
        "applicantWhatsappData",
        "applicantScheduleData",
        "applicantRating",
        // "applicantAssessments",
        "applicantJobMatch",
        "applicantQuestionnaires"
    ],
    blockedFields: ["applicantAssessments", "cv", "documents"]
};
